let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fGvqc")).then(() => parcelRequire('6Izja'));